import BaseComponent from "./BaseComponent.js";
import {
	JewishCalendarPlugin,
	DatepickerPosition,
	LevcharityFormatter,
	CloseButtonPlugin
} from './EasePickPlugins.js';

export class DatePicker extends BaseComponent {
	/**
	 * @type {Core}
	 */
	easePick;

	#args = {};

	#defaultArgs = {
		range: false,
		rangeSecondElement: false,
		showMonths: 1,
		gridColumns: 1,
		datepickerPosition: 'right',
		readOnly: false,
		autoApply: true,

		header: '',

		time: false,
		seconds: false,
		dateFormat: 'YYYY-MM-DD',
		timeFormat: 'HH:mm:ss',

		levFormat: '',

		lock: null,

		inputElement: null,

		calendar: 'grigorian',

		EasePickArgs: {
			firstDay: 0,
		}
	};

	constructor(args) {
		super();

		this.#args = this.parseArgs(this.#defaultArgs, args);

		this.#initialize();
	}

	async #initialize() {
		const {
			easepick,
			TimePlugin,
			AmpPlugin,
			PluginManager,
			LockPlugin,
			RangePlugin
		} = await import('@easepick/bundle');

		const {Helper} = await import('../Helper.js');

		if (!this.#args.inputElement) return;

		this.#args.inputElement.classList.add('levcharity-date-picker');

		let options = {
			element: this.#args.inputElement,
			zIndex: 10,

			format: this.#args.dateFormat,
			grid: this.#args.gridColumns,
			calendars: this.#args.showMonths,
			header: this.#args.header,

			css: [
				Helper.getModuleAssetsUrl() + "/styles/easepick.css"
			],

			plugins: [AmpPlugin, CloseButtonPlugin, DatepickerPosition],
			AmpPlugin: {
				dropdown: {
					months: true,
					years: true,
					minYear: new Date().getFullYear() - 150
				},
				resetButton: true
			},

			...this.#args.EasePickArgs,

			setup: (picker) => {
				const query = new URLSearchParams(window.location.search);
				const myAccountPage = document.querySelector('.woocommerce-edit-account');
				if (query.get("page")?.toLowerCase() === "levcharity-transactions" || myAccountPage) {
					picker.on('show', () => {
						const wrapper = document.querySelector(`.easepick-wrapper`);
						if (!wrapper) return;

						const pickerEl = wrapper.shadowRoot?.querySelector(`.datepicker-position`);
						if (!pickerEl) return;


						if(myAccountPage){
							pickerEl.style.right = 'auto';
						}else{
							pickerEl.style.right = '0px';
							pickerEl.style.left = 'auto';
						}
						pickerEl.style.top = '0px';
						pickerEl.style.zIndex = '10';
					});
				}
			}
		};

		if (this.#args.range) {
			options.plugins.push(RangePlugin);
		}

		if (this.#args.time) {
			options.plugins.push(TimePlugin);
			options.format += ' ' + this.#args.timeFormat;
		}

		if (!this.#args.inputElement?.placeholder) {
			this.#args.inputElement.placeholder = options.format;
		}

		if (this.#args.levFormat) {
			options.plugins.push(LevcharityFormatter);
			options.format = this.#args.levFormat;
			options.isLevFormat = true;
		}

		if (this.#args.lock) {
			options.plugins.push(LockPlugin);
			options.LockPlugin = this.#args.lock;
		}

		if (this.#args.calendar === 'jewish') {
			options.plugins.push(JewishCalendarPlugin);
		}

		options.datepickerPosition = this.#args.datepickerPosition;

		this?.onCreate(options, this);

		const _options = this?.filterOptions(options, this);
		if (_options) {
			options = _options;
		}

		this.easePick = new easepick.create(options);
	}

	onCreate() {
		const query = new URLSearchParams(window.location.search);
		if (query.get("page")?.toLowerCase() === "levcharity-transactions") {
			this.#args.inputElement.addEventListener("click", () => {
				const wrapper = document.querySelector(`.easepick-wrapper`);
				if (!wrapper) return;

				const picker = wrapper.shadowRoot?.querySelector(`.datepicker-position`);
				if (!picker) return;

				picker.style.right = '0px';
				picker.style.left = 'auto';
				picker.style.top = '0px';
				picker.style.zIndex = '10';
			});
		}
	}

	filterOptions() {}
}
